<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <h1 class="title-default">Ferramentas</h1>
    <p class="welcome-message">
      Aqui você encontra e gerencia suas <span class="display-name">Ferramentas</span>!
    </p>

    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">description</mat-icon>
        <span>Ações de Exportação</span>
      </div>

      <div class="action-card-grid">
        <a class="action-card-link"
          [routerLink]="hasPermissaoMinhasExportacoes ? 'minhas-exportacoes' : null"
          [attr.aria-disabled]="!hasPermissaoMinhasExportacoes"
          [matTooltip]="!hasPermissaoMinhasExportacoes ? 'Você não possui permissão para acessar esta funcionalidade' : ''"
          matTooltipPosition="above">
          <app-action-card icon="history" title="Minhas exportações de dados"
            description="Visualize e baixe suas exportações realizadas."
            [interactive]="true" [disabled]="!hasPermissaoMinhasExportacoes">
          </app-action-card>
        </a>
        <a class="action-card-link"
          [routerLink]="hasPermissaoExportacaoAutomatizada ? 'automacao-extracao-dados' : null"
          [attr.aria-disabled]="!hasPermissaoExportacaoAutomatizada"
          [matTooltip]="!hasPermissaoExportacaoAutomatizada ? 'Você não possui permissão para acessar esta funcionalidade' : ''"
          matTooltipPosition="above">
          <app-action-card icon="schedule_send" title="Exportação Automatizada"
            description="Configure extrações automáticas de dados recorrentes."
            [interactive]="true" [disabled]="!hasPermissaoExportacaoAutomatizada">
          </app-action-card>
        </a>
        <a class="action-card-link"
          [routerLink]="hasPermissaoConfiguracaoIAWhatsapp ? 'inteligencia-artificial-whatsapp' : null"
          [attr.aria-disabled]="!hasPermissaoConfiguracaoIAWhatsapp"
          [matTooltip]="!hasPermissaoConfiguracaoIAWhatsapp ? 'Você não possui permissão para acessar esta funcionalidade' : ''"
          matTooltipPosition="above">
          <app-action-card icon="smart_toy" title="Configuração IA Resulth no Whatsapp"
            description="Configure os números de telefone que podem ter acesso aos agentes de IA do Resulth."
            [interactive]="true" [disabled]="!hasPermissaoConfiguracaoIAWhatsapp">
          </app-action-card>
        </a>
      </div>
    </div>
  </div>
</div>
